import axios from "axios";

const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const baseURL = isLocalhost
    ? "/dpdpa-engine/api/v1"
    : window.location.hostname.includes("consent-portal.stage.nyai.ai")
      ? "https://dpdpa.stage.nyai.ai/dpdpa-engine/api/v1"
      : window.location.hostname.includes("consent-portal.dev.nyai.ai") ? "https://dpdpa.dev.nyai.ai/dpdpa-engine/api/v1" : "https://portal.dpdpguard.in/dpdpa-engine/api/v1";


const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 || err.response?.status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);

export default api;
